<script>
import ArticleCard from './ArticleCard.vue';

export default {
    name: 'ContentArticleOverviewBlock',
    components: {
        ArticleCard,
    },
    props: {
        data: Object,
    },
    data() {
        return {
            containerId: 'article-overview__articles',
        };
    },
    methods: {
        getArticleUrl(article) {
            return `${this.$t('articles.baseUrl')}/${article.post_name}`;
        },
    }
};
</script>

<template>
    <div class="article-overview">
        <h2 class="article-overview__title">{{ data.title }}</h2>
        <div class="article-overview__articles" v-masonry gutter="32" transition-duration="0.3s" item-selector=".article-overview__article">
            <div v-masonry-tile class="article-overview__article" v-for="article in data.articles" v-bind:key="article.ID">
                <article-card
                    v-bind:title="article.post_title"
                    v-bind:excerpt="article.excerpt"
                    v-bind:link="getArticleUrl(article)">
                </article-card>
            </div>
        </div>
    </div>
</template>

<style lang="scss">
.article-overview {
    --s-gutter: 3.2rem;

    margin-left: 0;
    margin-right: 0;
    max-width: none;

    @include breakpoint('md-up') {
        margin-left: -11.6rem;
        margin-right: -11.6rem;
    }
}

.article-overview__title {
    font-size: 1.8rem;
    padding-bottom: 1.2rem;
    margin-top: 11.6rem;
    margin-bottom: 4rem;
    border-bottom: 0.1rem solid rgba($color-primary, 0.16);
}

.article-overview__articles {
    display: flex;
}

.article-overview__article {
    flex: 0 0 calc(50% - var(--s-gutter));
    width: calc(50% - var(--s-gutter));
    margin-bottom: 8.8rem;

    @include breakpoint('xs') {
        flex: 0 0 100%;
        width: 100%;
        margin-bottom: 7.2rem;
    }
}
</style>
